module.exports = __webpack_public_path__ + "img/new_index_cooperate_bg4.7f813610.png";